import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { FaHeadset, FaHandshake, FaMedal, FaCreditCard } from 'react-icons/fa';

export default function Viajes() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Duración de la animación
      once: true,     // Solo se anima una vez
    });
  }, []);

  const servicios = [
    {
      id: 'asesoramiento',
      icon: (
        <FaHeadset
          aria-label="Asesoramiento personalizado"
          className="text-3xl lg:text-5xl text-[#B49A56] group-hover:rotate-12 transition-transform duration-300"
        />
      ),
      titulo: 'Asesoramiento personalizado',
      descripcion: 'Brindamos acompañamiento en cada etapa para diseñar el viaje ideal.',
    },
    {
      id: 'compromiso',
      icon: (
        <FaHandshake
          aria-label="Compromiso"
          className="text-3xl lg:text-5xl text-[#B49A56] group-hover:rotate-12 transition-transform duration-300"
        />
      ),
      titulo: 'Compromiso',
      descripcion: 'Cuidamos cada experiencia como si fuera propia.',
    },
    {
      id: 'experiencia',
      icon: (
        <FaMedal
          aria-label="Experiencia y trayectoria"
          className="text-3xl lg:text-5xl text-[#B49A56] group-hover:rotate-12 transition-transform duration-300"
        />
      ),
      titulo: 'Experiencia y trayectoria',
      descripcion: 'Más de 15 años creando experiencias únicas con profesionalismo y compromiso.',
    },
    {
      id: 'formas-pago',
      icon: (
        <FaCreditCard
          aria-label="Formas de pago flexibles"
          className="text-3xl lg:text-5xl text-[#B49A56] group-hover:rotate-12 transition-transform duration-300"
        />
      ),
      titulo: 'Formas de pago flexibles',
      descripcion: 'Efectivo, transferencia, pagos parciales y tarjetas. Planificá tu viaje con la comodidad que necesitás.',
    },
  ];

  return (
    <section id="viajes" className="bg-white py-10 lg:py-20 px-4 text-center relative z-10">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-screen-xl mx-auto">
        {servicios.map((s) => (
          <div
            key={s.id}
            className="group p-4 lg:p-10 bg-white border rounded-xl shadow-sm hover:shadow-md transition duration-300"
            data-aos="fade-up" 
          >
            <div className="mb-4 lg:mb-6" title={s.titulo}>{s.icon}</div>
            <h3 className="text-base lg:text-xl font-bold mb-2">{s.titulo}</h3>
            <p className="text-sm lg:text-base text-gray-600">{s.descripcion}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
